export const clamp = (min, max, val) => Math.max(min, Math.min(max, val));

export const generateNumbers = (start, end) => {
  return Array.from({length: end - start + 1}, (_, index) => start + index);
};
